import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {
  StageRun,
  Workflow,
  WorkflowTemplate,
  WorkflowTemplateVersionSummary,
} from 'workflows/WorkflowConstants';

export function getWorkflowDisplayString(
  processesEnabledString: string,
  legacyWorkflowString: string
): string {
  return BenchlingConfig.WORKFLOWS_ENABLE || isFeatureEnabled({feature: ProcessesFeature.PROCESSES_DISCOVER})
    ? processesEnabledString
    : legacyWorkflowString;
}

export function getLatestWorkflowTemplateVersion(
  workflowTemplate: WorkflowTemplate
): WorkflowTemplateVersionSummary {
  return workflowTemplate.workflowTemplateVersions[0];
}

export function getLatestPublishedWorkflowTemplateVersion(
  workflowTemplate: WorkflowTemplate
): WorkflowTemplateVersionSummary | null {
  for (const workflowTemplateVersion of workflowTemplate.workflowTemplateVersions) {
    if (workflowTemplateVersion.version) {
      return workflowTemplateVersion;
    }
  }
  return null;
}

export function isWorkflowInitialized(workflow: Workflow): boolean {
  return workflow.workflowStages.length > 0;
}

export function getWorkflowsBaseUrl(): string {
  return BenchlingConfig.WORKFLOWS_ENABLE ? '/legacy-workflows' : '/workflows';
}

export function getWorkflowURL(workflowId: string): string {
  return `${getWorkflowsBaseUrl()}/view/${workflowId}`;
}

export function getShouldExpandFirstStageOnly(stageIdToStageRuns: {
  [stageId: string]: Array<StageRun>;
}): boolean {
  return Object.values(stageIdToStageRuns).some((stageRuns) => stageRuns.length > 10);
}

// Disable hovering for high-throughput workflows due to performance
export function getShouldDisableDetailsTableHovering(stageIdToStageRuns: {
  [stageId: string]: Array<StageRun>;
}): boolean {
  return Object.values(stageIdToStageRuns).some((stageRuns) => stageRuns.length > 30);
}

export function getShouldAggregateVisualization(stageIdToStageRuns: {
  [stageId: string]: Array<StageRun>;
}): boolean {
  return Object.values(stageIdToStageRuns).some((stageRuns) => stageRuns.length > 120);
}
